// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"d47b7df7","123":"8e4e8340","153":"3c3b8dc8","695":"52db34d8"}[chunkId] + ".chunk.css";
};